var _defs, _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1da1f2;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2500,
    height: 2500,
    rx: 322.34043
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.09989,368.29787c-110.649,0-200.37188,90.43562-200.37188,201.99562,0,111.54779,89.71056,201.98959,200.37188,201.98959,110.65513,0,200.36561-90.43577,200.35936-201.98959C860.45925,458.73349,770.74877,368.29787,660.09989,368.29787Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1702.64543,882.25022c-232.12037,0-329.87642,180.82814-329.87642,180.82814V915.64147H1047.78312V2010.33476H1372.769V1435.71158c0-153.95148,70.85466-245.57725,206.4836-245.57725,124.6202,0,184.48511,87.975,184.48511,245.57725v574.62318h337.19654l.00618-693.14386C2100.94044,1023.98456,1934.772,882.25022,1702.64543,882.25022Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 492.2948,
    y: 915.64147,
    width: 338.8395,
    height: 1094.69329
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIc);
export default __webpack_public_path__ + "static/media/linkedin-ic.3f0ae95f3c783aab5dafb52fe99b2707.svg";
export { ForwardRef as ReactComponent };